module.exports = __webpack_public_path__ + "img/sarl-rivalin.85e5f773.png";